import SignIn from "../pages/SignIn";
import Assets from "../pages/Assets";
import Bets from "../pages/Bets";
import Instruments from "../pages/Instruments";
import ConfirmedUsers from "../pages/ConfirmedUsers";
import NonConfirmedUsers from "../pages/NonConfirmedUsers";
import Profitability from "../pages/Profitability";
import Bankroller from "../pages/Bankroller";
import Maintenance from '../pages/Maintenance';
import Affiliates from '../pages/Affiliates';
import RiskAnalysisManagement from '../pages/RiskAnalysisManagement';


export const SIGN_IN_PAGE = "/",
  ASSETS_PAGE = "/assets",
  BETS_PAGE = "/bets",
  INSTRUMENTS_PAGE = "/instruments",
  CONFIRMED_USERS_PAGE = "/confirmed-users",
  NON_CONFIRMED_USERS_PAGE = "/non-confirmed-users",
  PROFITABILITY_PAGE = "/profitability",
  MAINTENANCE_PAGE = "/maintenance",
  BANKROLLER_PAGE = "/syndicate",
  RISK_ANALYSIS_MANAGMENT_PAGE = "/risk";

export default [
  {
    path: SIGN_IN_PAGE,
    component: SignIn,
    exact: true,
  },
  {
    path: ASSETS_PAGE,
    component: Assets,
    exact: true,
  },
  {
    path: BETS_PAGE,
    component: Bets,
    exact: true,
  },
  // {
  //   path: INSTRUMENTS_PAGE,
  //   component: Instruments,
  //   exact: true,
  // },
  {
    path: CONFIRMED_USERS_PAGE,
    component: ConfirmedUsers,
    exact: true,
  },
  {
    path: NON_CONFIRMED_USERS_PAGE,
    component: NonConfirmedUsers,
    exact: true,
  },
  {
    path: PROFITABILITY_PAGE,
    component: Profitability,
    exact: true,
  },
  {
    path: BANKROLLER_PAGE,
    component: Bankroller,
    exact: true,
  },
  {
    path: MAINTENANCE_PAGE,
    component: Maintenance,
    exact: true,
  },
  {
    path: RISK_ANALYSIS_MANAGMENT_PAGE,
    component: RiskAnalysisManagement,
    exact: true,
  }
];
